<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="groupsPromise" />
    <Placy
      v-if="!items.length"
      :promise="groupsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('GROUP', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('GROUP', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @keydown.esc="searchTerm = ''"
        />
        <i class="search icon" />
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-group' }">
      <i class="plus icon" />
      <strong>{{ $t('NEW', { thing: $tc('GROUP', 1) }) }}</strong>
    </router-link>

    <single-group :key="group.original.id" v-for="group in filteredItems" :group="group" />
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}
</style>

<script>
// @flow
import { Spinny, Placy } from 'ui'
import { Group } from 'services'
import SingleGroup from './SingleGroup'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'group-list',
  components: { Spinny, Placy, SingleGroup },
  mixins: [FuzzyFilterer],

  data() {
    return {
      groupsPromise: null
    }
  },

  computed: {
    groups() {
      return this.$store.state.group.items
    },
    items() {
      return this.groups.map(group => this.processGroupName(group))
    }
  },

  methods: {
    processGroupName(group) {
      const indexOfDomainSeparator = group.name.indexOf('\\')
      if (indexOfDomainSeparator !== -1) {
        const groupDomain = group.name.substr(0, indexOfDomainSeparator)
        const groupName = group.name.substr(indexOfDomainSeparator + 1)
        return { ...group, domain: groupDomain, name: groupName }
      }
      return group
    }
  },

  created() {
    this.groupsPromise = Group.readAllGroups()
  }
}
</script>
